var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.state.aws_loading),expression:"$store.state.aws_loading"}],attrs:{"element-loading-background":"rgba(0, 0, 0, 0.6)"}},[_c('Header'),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }